import { render } from "./NewFeatures.vue?vue&type=template&id=0fce5834&scoped=true"
import script from "./NewFeatures.vue?vue&type=script&lang=js"
export * from "./NewFeatures.vue?vue&type=script&lang=js"

import "./NewFeatures.vue?vue&type=style&index=0&id=0fce5834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fce5834"]])

export default __exports__